import { render, staticRenderFns } from "./PopupAlertCaseEntity.vue?vue&type=template&id=36da5277&scoped=true"
import script from "./PopupAlertCaseEntity.vue?vue&type=script&lang=js"
export * from "./PopupAlertCaseEntity.vue?vue&type=script&lang=js"
import style0 from "./PopupAlertCaseEntity.vue?vue&type=style&index=0&id=36da5277&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da5277",
  null
  
)

export default component.exports